var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":_vm.previewHandle}},[_vm._t("default")],2),(_vm.previewShow)?_c('el-image-viewer',{attrs:{"url-list":[_vm.previewUrl],"on-close":() => _vm.previewShow = false,"append-to-body":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }